import { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../../../../hooks/useAuth';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { modalStyle } from '../../../../../../../utils/modal';
import { Spinner } from '../../../../../../../components/Spinner';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';

function PopupMessageModal({ aggregators, popupMessageModal, closeModal, setPopupMessage }) {
  const { getAccessTokenSilently } = useAuth();

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [aggregatorIds, setAggregatorIds] = useState([]);
  const [editMode, setEditMode] = useState(false);

  const [spinnerModal, setSpinnerModal] = useState(false);

  useEffect(() => {
    if (popupMessageModal) {
      setStartDate(popupMessageModal.startDate);
      setEndDate(popupMessageModal.endDate);
      setAggregatorIds(popupMessageModal.aggregatorIds);
    }
  }, [popupMessageModal]);

  const handleUpdate = async () => {
    setSpinnerModal(true);

    const token = await getAccessTokenSilently();

    if (!token) {
      return;
    }

    try {
      setPopupMessage(prevMessage => ({
        ...prevMessage,
        activationPeriods:
          popupMessageModal.tempId === 'new'
            ? [
                ...prevMessage.activationPeriods,
                { start: startDate, end: endDate, aggregatorIds, tempId: crypto.randomUUID() },
              ]
            : prevMessage.activationPeriods.map(x =>
                x.tempId === popupMessageModal.tempId
                  ? { ...x, start: startDate, end: endDate, aggregatorIds }
                  : { ...x },
              ),
      }));

      closeModal();
    } catch (err) {
      toast.error(err.message);
    } finally {
      setSpinnerModal(false);
    }
  };

  return (
    <ReactModal
      isOpen={!!popupMessageModal}
      style={modalStyle({ width: '460px' })}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      onRequestClose={closeModal}
    >
      <Spinner visible={spinnerModal}>
        <div className="bo-modal-form bo-h-500">
          <div>
            <div className="gap-3 d-flex flex-column">
              <div className="d-flex flex-column">
                <Form.Label>From</Form.Label>
                <DatePicker
                  className="bo-input bo-date-picker"
                  onChange={e => setStartDate(moment(e).format('YYYY-MM-DD'))}
                  selected={new Date(startDate)}
                  dateFormat="yyyy-MM-dd"
                  customInput={<Form.Control />}
                />
              </div>
              <div className="d-flex flex-column">
                <Form.Label>To</Form.Label>
                <DatePicker
                  className="bo-input bo-date-picker"
                  onChange={e => setEndDate(moment(e).format('YYYY-MM-DD'))}
                  selected={new Date(endDate)}
                  dateFormat="yyyy-MM-dd"
                  customInput={<Form.Control />}
                />
              </div>
              <div className="d-flex flex-column">
                <Form.Label>Aggregators</Form.Label>
                {aggregatorIds.length === 0 ? (
                  <Form.Select
                    className="bo-filter w-100"
                    onChange={e => setAggregatorIds(prev => [...prev, Number(e.target.value)])}
                  >
                    <option value="">All Aggregators</option>
                    {aggregators.map(agg => (
                      <option key={agg.id} value={agg.id}>
                        {agg.name}
                      </option>
                    ))}
                  </Form.Select>
                ) : (
                  <div className="d-flex flex-column gap-2">
                    {aggregatorIds.map(x => (
                      <div key={x} className="d-flex gap-2 align-items-center">
                        <Form.Control
                          className="bo-input w-100"
                          readOnly
                          value={aggregators.find(agg => agg.id === x)?.name}
                        />
                        <Button
                          className="bo-common-base-button"
                          onClick={() =>
                            setAggregatorIds(pAggs => pAggs.filter(pAgg => pAgg !== x))
                          }
                        >
                          <FontAwesomeIcon icon={faTrashAlt} color="#5946A4" size="1x" />
                        </Button>
                      </div>
                    ))}
                    {editMode ? (
                      <Form.Select
                        className="bo-filter w-100"
                        defaultValue=""
                        onChange={e => {
                          setEditMode(false);
                          setAggregatorIds(prev => [...prev, Number(e.target.value)]);
                        }}
                      >
                        <option value="" disabled>
                          Select Aggregator...
                        </option>
                        {aggregators
                          .filter(agg => !aggregatorIds.includes(agg.id))
                          .map(agg => (
                            <option key={agg.id} value={agg.id}>
                              {agg.name}
                            </option>
                          ))}
                      </Form.Select>
                    ) : (
                      <Button
                        className="bo-common-inline-button align-self-start ms-2"
                        onClick={() => setEditMode(true)}
                      >
                        Add Aggregator
                      </Button>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <Row>
            <Col className="mt-5 d-flex gap-3 justify-content-between">
              <Button className="bo-button" disabled={!popupMessageModal} onClick={handleUpdate}>
                OK
              </Button>
              <Button className="bo-button" onClick={closeModal}>
                Cancel
              </Button>
            </Col>
          </Row>
        </div>
      </Spinner>
    </ReactModal>
  );
}

export default PopupMessageModal;
